import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b11c4e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "prizeDialog",
  "data-test": "join-dialog"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "prizeDialog__header" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "prizeDialog__kkb" }, null, -1))
const _hoisted_4 = { class: "prizeDialog__text" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "prizeDialog__decoration" }, null, -1))
const _hoisted_7 = ["onClick"]

import { useObtainPrize } from '@/hooks/useObtainPrize';
import { computed } from 'vue';
import { useStore } from '@/store';
import { useTrack } from '@/hooks/useTrack';


export default /*#__PURE__*/_defineComponent({
  emits: ["close"],
  setup(__props, { emit }: { emit: ({
  (e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const store = useStore();
const obtainPrize = useObtainPrize();


const { trackBtn } = useTrack();

const previousPeriodObtainCount = computed(() => store.state.previousPeriodObtainCount);

function onClose () {
  emit('close');
}

async function onClick () {
  loading.show();
  trackBtn('立即领取', {
    CoinAmount: previousPeriodObtainCount.value
  });
  await obtainPrize();
  loading.hide();
  emit('close');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "prizeDialog__container",
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
    }, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, "恭喜！上期获得" + _toDisplayString(_unref(previousPeriodObtainCount)) + "KK币", 1),
      _createElementVNode("div", {
        class: "prizeDialog__button",
        onClick: _withModifiers(onClick, ["stop"])
      }, "立即领取", 8, _hoisted_5),
      _hoisted_6
    ]),
    _createElementVNode("div", {
      class: "prizeDialog__close",
      "data-test": "close-btn",
      onClick: _withModifiers(onClose, ["stop"])
    }, null, 8, _hoisted_7)
  ]))
}
}

})